import React from 'react';
import { Button, Flex, theme } from 'antd';
import { useNavigate } from 'react-router-dom';

import useTrackSetupChecklistEvent from './useTrackChecklistEvent';

type ChecklistItemActionsProps = {
  primaryButtonLabel: string;
  primaryButtonLink: string;
  learnMoreHref: string;
  itemKey: string;
  onMarkAsDone?: () => void;
};
export function ChecklistItemActions({
  primaryButtonLabel,
  primaryButtonLink,
  learnMoreHref,
  itemKey,
  onMarkAsDone,
}: ChecklistItemActionsProps) {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const trackSetupChecklistEvent = useTrackSetupChecklistEvent();

  const isCompleted = !onMarkAsDone;

  const handlePrimaryButtonClick = () => {
    trackSetupChecklistEvent('ItemClicked', { item_name: itemKey, is_completed: isCompleted });
    navigate(primaryButtonLink);
  };

  return (
    <Flex style={{ marginTop: token.marginMD }} justify="space-between">
      <div>
        <Button type="primary" style={{ marginRight: token.marginSM }} onClick={handlePrimaryButtonClick}>
          {primaryButtonLabel}
        </Button>
        <Button
          href={learnMoreHref}
          variant="link"
          color="default"
          target="_blank"
          onClick={() => trackSetupChecklistEvent('LearnMoreClicked', { item_name: itemKey })}
        >
          Learn more
        </Button>
      </div>
      {!isCompleted && (
        <Button color="primary" variant="text" onClick={onMarkAsDone}>
          Mark as done
        </Button>
      )}
    </Flex>
  );
}
